<template>
    <footer class="footer-box">
        <wx-open-launch-app
            v-if="isWeiXin() && !isInRyH5()"
            style="position: fixed; bottom: 50px; left: 50%; display: inline-block; transform: translateX(-50%)"
            id="launch-btn"
            :appid="appid"
            :extinfo="extinfo"
            @launch="$emit('launch', $event)"
            @error="$emit('error', $event)"
        >
            <script type="text/wxtag-template">
                <style>
                .footer-btn {
                    padding: 6px 12px;
                    background-color: #FF6907;
                    font-size: 14px;
                    border-radius: 31px;
                    color: #fff;
                    border: 1px solid;
                }
                </style>
                <button class="footer-btn">{{$t('openAppMsg')}}</button>
            </script>
        </wx-open-launch-app>
        <button v-if="isInOutsideH5() && !isWeiXin() && !isInRyH5()" class="footer-btn" @click="$emit('open-app')">
            {{ $t('openAppMsg') }}
        </button>
    </footer>
</template>

<script>
import { isWeiXin, isInOutsideH5, isInRyH5 } from '@/utils'

export default {
    name: 'OpenAppFooter',
    props: {
        appid: {
            type: String,
            default: ''
        },
        extinfo: {
            type: String,
            default: ''
        }
    },
    methods: {
        isWeiXin,
        isInOutsideH5,
        isInRyH5
    }
}
</script>

<style lang="less" scoped>
.footer-box {
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);

    .footer-btn {
        padding: 6px 12px;
        color: #fff;
        font-size: 14px;
        background-color: #ff6907;
        border: 1px solid;
        border-radius: 31px;
    }
}
</style>
